import { render, staticRenderFns } from "./RemindersView.vue?vue&type=template&id=4c362056&scoped=true"
import script from "./RemindersView.vue?vue&type=script&lang=js"
export * from "./RemindersView.vue?vue&type=script&lang=js"
import style0 from "./RemindersView.vue?vue&type=style&index=0&id=4c362056&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c362056",
  null
  
)

export default component.exports